// The dashboard page's three names for its dashboard, parts separated by an em
// dash (ANS-563): the heading, the Jitto frame's title and the browser tab.
const SEP = ' — ';

export function dashboardTitles(name) {
  const heading = `Dashboard${SEP}${name}`;
  return {
    heading,
    frame: heading,
    tab: `PARAMETA Solutions Trading Analytics${SEP}${heading}`,
  };
}
